var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRoles = function SvgRoles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F4651",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.521 3H11.52a33 33 0 0 0-1.674.067c-4.191.278-7.53 3.658-7.805 7.902-.053.83-.053 1.69 0 2.52.1 1.546.785 2.976 1.591 4.185.468.846.16 1.901-.328 2.823-.352.665-.527.998-.386 1.238.14.24.456.248 1.086.263 1.247.03 2.088-.322 2.755-.814.379-.278.568-.417.698-.433s.388.09.9.3c.462.19.998.307 1.49.34 1.426.094 2.92.094 4.35 0C18.215 21.123 21.501 18 22 14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F4651",
    strokeWidth: 1.5,
    d: "M15.59 8.648c-.629.369-2.277 1.121-1.273 2.063.49.46 1.037.789 1.723.789h3.92c.686 0 1.233-.329 1.723-.789 1.004-.942-.644-1.694-1.273-2.063a4.8 4.8 0 0 0-4.82 0ZM20 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F4651",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M11.996 12.5h.008M8 12.5h.009"
  })));
};
export default SvgRoles;